module.exports = __webpack_public_path__ + "img/add-room-bg.8eae6b6b.svg";